export default __webpack_public_path__ + "static/media/11.af343a9a.jpg";